import {mean} from 'd3-array';
import {transition} from 'd3-transition';

const stroke = '#aaa';

function _meanLine() {
  if (!this.meanLine() || this.isFacet()) return;
  const canvas = this.__execs__.canvas;
  const ms = [];
  const scale = this.__execs__.scale;
  const trans = transition().duration(this.transition().duration).delay(this.transition().delay);  
  this.regions().each(d => {
    let result = {value: mean(d.children, d => d.value)};
    result.y = scale.y(result.value);
    ms.push(result);
  })
  let meanLineG = canvas.select('.mean-line-g')
  if (meanLineG.empty) {
    meanLineG = canvas.append('g').attr('class', 'mean-line-g')
  }
  let meanLine =meanLineG.selectAll('.mean-line')
    .data(ms)
  meanLine.exit().remove();

  let meanLineEnter = meanLine.enter().append('g')
    .attr('class', 'mean-line')
    .attr('transform', 'translate(' + [0, scale.y.range()[0]]+')')
    .style('pointer-events', 'none');
  meanLineEnter.append('line')
    .attr('stroke', stroke)
    .attr('shape-rendering', 'crispEdges')
    .attr('stroke-width', '2px')
    .attr('x2', scale.x.range()[1]);
    
  meanLine = meanLineEnter.merge(meanLine)
    .transition(trans)
    .attr('transform', d => 'translate(' + [0, d.y]+')');
  meanLine.select('line')
    .transition(trans)
    .attr('x2', scale.x.range()[1]);
}

export default _meanLine;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/line/_meanLine.js